/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_MoreInputs */

const en_history_more = /** @type {(inputs: History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show older`)
};

const de_history_more = /** @type {(inputs: History_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ältere anzeigen`)
};

/**
* | output |
* | --- |
* | "Show older" |
*
* @param {History_MoreInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_more = /** @type {((inputs?: History_MoreInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_MoreInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_more(inputs)
	return en_history_more(inputs)
});